// extracted by mini-css-extract-plugin
export default {"Wrapper":"SelectedItem_Wrapper__lNpjk"};